import { messengerEventKey } from '@/models/Messenger';
import { useEventBus } from '@vueuse/core';

const eventBus = useEventBus(messengerEventKey);

export default eventBus;
